import { render } from "./ReportGeneral.vue?vue&type=template&id=e5c9ffd2&scoped=true"
import script from "./ReportGeneral.vue?vue&type=script&lang=js"
export * from "./ReportGeneral.vue?vue&type=script&lang=js"

import "./ReportGeneral.vue?vue&type=style&index=0&id=e5c9ffd2&scoped=true&lang=css"
import "./ReportGeneral.vue?vue&type=style&index=1&id=e5c9ffd2&lang=css"
import "./ReportGeneral.vue?vue&type=style&index=2&id=e5c9ffd2&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c9ffd2"]])

export default __exports__